import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";

import {
    SidebarNavItem,
    SidebarNavItemProps,
} from "../SidebarNavItem/SidebarNavItem";
import { Sidebar, SidebarContent, SidebarInner } from "./SidebarNav.styles";
import { SidebarNavPopoutMenu } from "../SideBarNavPopoutMenu/SidebarNavPopoutMenu";

// Adjusting the item structure to accommodate subitems
export interface NavItem extends SidebarNavItemProps {
    subItems?: NavItem[];
}

export interface SidebarNavProps {
    items: NavItem[];
    setModalOpen?: (e: boolean) => void;
    setChatExitModalOpen?: (e: boolean) => void;
}

export const SidebarNav: React.FC<SidebarNavProps> = ({
                                                          items,
                                                          setModalOpen,
                                                          setChatExitModalOpen,
                                                      }) => {
    const location = useLocation();
    const { id: patientId } = useParams<{ id: string }>();

    useEffect(() => {
        if (!patientId) return;

        const chatSeenKey = `patient_${patientId}_chat_seen`;
        const chatSeen = localStorage.getItem(chatSeenKey) === "yes";

        if (chatSeen) {
            // Show modal
            setChatExitModalOpen?.(true);

            // Optional: clean up after showing
            localStorage.setItem(chatSeenKey, "done");
        }
    }, [location.pathname, patientId, setChatExitModalOpen]);


    return (
        <Sidebar>
            <SidebarContent>
                <SidebarInner>
                    {items.map((item, index) =>
                        item.subItems && item.subItems.length > 0 ? (
                            <SidebarNavPopoutMenu
                                key={index}
                                mainItem={item}
                                subItems={item.subItems}
                            />
                        ) : item.href === "/patients/:id/guidelines" ? (
                            <div key={index} onClick={() => setModalOpen?.(true)}>
                                <SidebarNavItem
                                    name={item.name}
                                    Icon={item.Icon}
                                />
                            </div>
                        ) : (
                            <SidebarNavItem
                                key={index}
                                name={item.name}
                                href={item.href.replace(":id", patientId!)}
                                Icon={item.Icon}
                            />
                        )
                    )}
                </SidebarInner>
            </SidebarContent>
        </Sidebar>
    );
};
